import axios from "axios";

const api = axios.create({
 //baseURL: "http://localhost:8080/api"
 baseURL: "https://archanapriya-solar-crm-backend.hf.space/api"

});

api.interceptors.request.use(config => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

api.interceptors.response.use(
  response => response,
  error => {

    if (error.response && error.response.status === 401) {

      // session expired
      localStorage.removeItem("token");
      localStorage.removeItem("role");

      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default api;